export default {
    "app.save-changes": "Guardar cambios",
    "app.required-fields": "* campos requeridos",
    "app.month": "mes",
    "users.login.dont-have-account": "¿No tienes una cuenta?",
    "users.login.sign-up": "Registrarse",
    "users.login.forgot-password": "¿Olvidaste tu contraseña?",
    "users.login.log-in": "Iniciar sesión",
    "users.login.enable-user": "Habilitar cuenta e iniciar sesión",
    "users.login.bad-password": "Contraseña incorrecta",
    "users.login.bad-email": "Este correo electrónico no tiene una cuenta",
    "users.login.error-disabled": "Esta cuenta está desactivada actualmente",
    "users.login.already-have-account": "¿Ya tienes una cuenta?",
    "users.login.google": "Iniciar sesión con",
    "users.login.or": "O",
    "users.signup.invalid-email": "Correo electrónico no válido",
    "users.signup.invalid-password": "La contraseña debe tener al menos 6 caracteres",
    "users.signup.email-used": "Este correo electrónico ya está en uso",
    "users.signup.password-unmatched": "Las contraseñas no coinciden",
    "users.input.user": "Nombre de usuario",
    "users.input.email": "Dirección de correo electrónico",
    "users.input.password": "Contraseña",
    "users.input.confirm-password": "Confirmar contraseña",
    "users.password-format": "La contraseña debe tener al menos 6 caracteres",
    "users.log-out": "Cerrar Sesión",
    "users.recover-password.title": "Restablecer tu contraseña",
    "users.recover-password.send": "Enviar correo electrónico",
    "users.recover-password.sent-toast": "Se envió un correo electrónico a {email}. Sigue las instrucciones para restablecer tu contraseña.",
    "users.recover-password.error.email": "Debes escribir un correo electrónico válido",
    "users.recover-password.error.no-account": "Este correo electrónico no está vinculado a ninguna cuenta",
    "app.error.not-found": "Ups, algo salió mal",
    "app.error.not-found-message": "Esta página no se encontró. Intenta volver a la página de inicio",
    "app.error.not-logged-in": "Esta página no se encontró. Intenta iniciar sesión.",
    "app.error.go-home": "Ir a la página de inicio",
    "app.home": "Inicio",
    "app.search": "Buscar",
    "app.group": "Grupos",
    "app.menu": "Menú",
    "app.my-drive": "Mi Drive",
    "app.my-profile": "Mi Perfil",
    "app.squad-flix": "SquadFlix",
    "app.verify-account": "Enviar correo de verificación",
    "app.verify-account.send-success": "Correo de verificación enviado exitosamente",
    "app.verify-account-message": "Algunas funciones están desactivadas hasta la verificación",
    "app.verify-account-again": "Correo de verificación enviado nuevamente.",
    "app.verify-account-again.countdown": "Enviar nuevamente en ",
    "input-save-edit.invalid-feedback": "Este campo es obligatorio",
    "selector-save-edit.invalid-feedback": "Debes seleccionar una opción",
    "profile.image.not-verified": "No puedes cambiar tu foto de perfil hasta que verifiques tu correo electrónico",
    "profile.crop-modal.title": "Recortar nueva imagen",
    "profile.crop-modal.complete": "Completar recorte",
    "profile.change-password": "Cambiar contraseña",
    "profile.change-password.save": "Guardar nueva contraseña",
    "profile.user-info": "Información de usuario",
    "profile.app-config": "Opciones de la aplicación",
    "profile.app-config.dark-mode": "Modo oscuro",
    "profile.app-config.receive-emails": "Recibir correos electrónicos",
    "profile.current-password": "Contraseña actual",
    "profile.new-password": "Nueva contraseña",
    "profile.confirm-new-password": "Confirmar nueva contraseña",
    "profile.update-password": "Cambiar contraseña",
    "profile.update-password.text": "Ingresa tu contraseña actual y una nueva contraseña",
    "profile.update-password.unchanged-password": "La nueva contraseña debe ser diferente de la actual",
    "profile.user-suppress": "Eliminar cuenta",
    "profile.user-suppress.text": "Puedes recuperar tu cuenta en cualquier momento después de desactivarla",
    "profile.user-suppress.disable": "Desactivar cuenta",
    "profile.user-suppress.delete": "Eliminar cuenta",
    "profile.user-delete.warning.title": "Eliminar cuenta",
    "profile.user-delete.warning.message": "¿Estás seguro de que deseas eliminar tu cuenta? Todos tus archivos e información se eliminarán. Confirma tu contraseña y continúa si deseas hacerlo.",
    "profile.user-delete.warning.message-google": "¿Estás seguro de que deseas eliminar tu cuenta? Todos tus archivos e información se eliminarán. Presiona continuar e inicia sesión con tu cuenta de Google para confirmar.",
    "profile.user-delete.warning.button": "Continuar",
    "profile.user-delete.confirm.message": "Tu cuenta se eliminará por completo. ¡Esta acción no se puede deshacer!",
    "profile.user-delete.confirm.button": "¡ELIMINAR!",
    "profile.user-delete.incorrect-password": "Contraseña incorrecta, no se pudo continuar con la eliminación de tu cuenta.",
    "profile.user-delete.incorrect-account": "Cuenta de Google incorrecta, no se pudo continuar con la eliminación de tu cuenta.",
    "profile.user-delete.error-deleting": "Hubo un error inesperado al eliminar tu cuenta, inténtalo de nuevo más tarde.",
    "profile.user-delete.successfully-deleted": "Tu cuenta se eliminó correctamente",
    "profile.auth-method": "Método de autenticación",
    "profile.auth-method.google-text": "Sesión iniciada con",
    "profile.auth-method.password-text": "Autenticado con correo electrónico + contraseña",
    "profile.change-username.success": "Tu nombre de usuario se ha actualizado correctamente",
    "profile.change-username.error": "Solo puedes cambiar tu nombre de usuario una vez cada 30 días",
    "profile.change-photo.success": "Tu foto de perfil se ha actualizado correctamente",
    "profile.change-password.success": "Tu contraseña se ha actualizado correctamente",
    "profile.user-code": "ID de usuario",
    "profile.manage-subscription": "Gestionar Suscripción",
    "modal.cancel": "Cancelar",
    "modal.confirm": "Confirmar",
    "modal.close": "Cerrar",
    "drive.contextual.add-file": "Seleccionar archivos",
    "drive.contextual.files.empty": "Selecciona archivos para cargar o arrástralos directamente aquí.",
    "drive.contextual.files.empty-phone": "Selecciona archivos para cargar, la cola de carga aparecerá aquí.",
    "drive.contextual.queue.exceeds-size": "1 o más archivos no se pueden cargar. El tamaño máximo del archivo es {fileSize}",
    "drive.contextual.queue.already-uploading": "No se pudo agregar a la cola: este archivo ya se está cargando",
    "drive.no-files": "Esto está vacío, intenta subir nuevos archivos.",
    "drive.create-folder": "Nueva carpeta",
    "drive.create-folder-short": "Carpeta",
    "drive.new-folder.name": "Nombre de la carpeta",
    "drive.create-folder.error-name": "El nombre de la carpeta debe tener al menos 3 caracteres.",
    "drive.create-folder.success": "Nueva carpeta creada exitosamente",
    "drive.files-selected-info": "archivos",
    "drive.folders-selected-info": "carpetas",
    "drive.move-selected": "Mover",
    "drive.delete-selected": "Eliminar",
    "drive.recycle-bin": "Papelera de reciclaje",
    "drive.recycle-bin-short": "Papelera",
    "drive.file-row.delete-button": "Eliminar de la papelera",
    "drive.file-row.recover-button": "Restaurar elemento",
    "drive.no-recycle-bin.no-files": "Tu papelera de reciclaje está vacía",
    "drive.recycle-bin.confirm-delete.title": "Eliminar elemento de la papelera",
    "drive.recycle-bin.confirm-delete-all.title": "Eliminar todos los elementos",
    "drive.recycle-bin.confirm-delete.message": "¿Estás seguro de que deseas continuar? Esta acción no se puede deshacer. El siguiente archivo se eliminará permanentemente:",
    "drive.recycle-bin.confirm-delete-all.message": "¿Estás seguro de que deseas continuar? Esta acción no se puede deshacer. La papelera se vaciará y se eliminarán todos los archivos y carpetas.",
    "drive.contextMenu.delete-item": "Eliminar elemento",
    "drive.contextMenu.change-name": "Cambiar nombre",
    "drive.contextMenu.open-item": "Abrir",
    "drive.delete-selected.confirm-trash": "Confirmar eliminar carpetas",
    "drive.delete-selected.confirm-trash.message": "Has seleccionado una o más carpetas. Estas carpetas se eliminarán y todos sus elementos se moverán a la papelera de reciclaje.",
    "drive.recycle-bin.deleted-trash": "Todos tus archivos en la papelera de reciclaje se han eliminado correctamente.",
    "drive.recycle-bin.clean-bin": "Vaciar",
    "drive.change-name.file-success": "El nombre del archivo se ha actualizado.",
    "drive.change-name.folder-success": "El nombre de la carpeta se ha actualizado.",
    "drive.removed-items.moved-trash": "Uno o más elementos se han movido a la papelera de reciclaje.",
    "drive.moved-items.success": "Uno o más elementos se han movido a",
    "fileUploadMenu.drop-items.folder-forbidden": "No se pueden cargar carpetas. Debes seleccionar solo archivos.",
    "file-viewer.uploaded-on": "Subido el",
    "file-viewer.share-file": "Compartir",
    "file-viewer.publish-file": "Publicar",
    "file-viewer.publish-file.form-title": "Publicar archivo en grupos",
    "file-viewer.publish-file.form.title": "Título",
    "file-viewer.publish-file.form.description": "Descripción",
    "file-viewer.publish-file.form.select-groups": "Seleccionar grupos",
    "file-viewer.publish-file.form.selected-groups": "Seleccionar grupos: ",
    "file-viewer.publish-file.form.description-placeholder": "Escribe una breve descripción de lo que estás compartiendo",
    "file-viewer.publish-file.form.no-valid-groups": "No tienes permiso para publicar archivos en ningún grupo.",
    "file-viewer.publish-file.upload-info.wait": "Por favor, espera mientras tu archivo \"{fileName}\" se comparte con tus grupos.",
    "file-viewer.publish-file.finished-title": "Archivo publicado",
    "file-viewer.publish-file.finished-info": "Tu archivo \"{fileName}\" se ha compartido con los siguientes grupos:",
    "file-viewer.publish-file.reload-form": "Abrir formulario de publicación nuevamente",
    "file-viewer.download-file": "Descargar",
    "file-viewer.file-not-supported": "Archivo no compatible con el visor de archivos",
    "file-viewer.mkv-warning": "Algunos exploradores pueden tener problemas para reproducir archivos MKV",
    "file-viewer.share-link-copied": "El enlace de compartir se copió en tu portapapeles",
    "profile.drive-status": "Estado de mi Drive",
    "drive.user-size.total-size-info": "{usedSize} de {totalSize} utilizado",
    "drive.user-size.need-space?": "¿Necesitas más espacio?",
    "drive.user-size.max-size": "El tamaño máximo del archivo es {maxFileSize}",
    "errors.no-size": "El archivo {fileName} ({size}) excede tu tamaño total.",
    "drive.select-all-files": "Seleccionar todos los archivos",
    "drive.select-all-folders": "Seleccionar todas las carpetas",
    "groups.create-group": "Nuevo grupo",
    "groups.create-group-small": "Crear",
    "groups.title": "Grupos",
    "my-groups.title": "Mis Grupos",
    "groups.group-form.group-name": "Nombre del grupo",
    "groups.group-form.privacy": "Privacidad",
    "groups.group-form.select-privacy": "Selecciona la privacidad del grupo",
    "groups.group-form.categories": "Categorías",
    "groups.group-form.confirm-create": "Crear",
    "groups.privacy.public": "Público",
    "groups.privacy.private": "Privado",
    "groups.privacy.hidden": "Oculto",
    "groups.group-leader": "Líder",
    "groups.member": "Miembro",
    "groups.members": "Miembros",
    "groups.no-my-groups": "Los grupos en los que estás aparecerán aquí",
    "groups.join-group": "Unirse",
    "groups.join-group.error": "Error al unirse: este grupo podría haber sido eliminado",
    "groups.reject-join-group": "Rechazar",
    "groups.ask-to-join": "Solicitar unirse",
    "groups.invitation": "Invitación",
    "groups.already-asked": "Has solicitado unirte",
    "groups.join-more-groups": "¿Quieres unirte a más grupos?",
    "group-search.title": "Buscar grupos",
    "groups.group-limit-reached": "Has alcanzado el número máximo de grupos a los que puedes unirte.",
    "group-search.input-searcher": "Búsqueda de grupos",
    "group-search.input-searcher.text": "La búsqueda se realizará por nombre del grupo y categorías.",
    "search-results.title": "Resultados de búsqueda",
    "group-search.no-results": "No se encontraron grupos para las palabras clave de búsqueda proporcionadas",
    "group-search.showing-results": "Mostrando resultados para: ",
    "group-search.load-more": "Cargar más elementos",
    "group-details.search-files": "Buscar archivos en el grupo",
    "group-details.group-menu": "Menú del grupo",
    "group-details.group-menu.join-petitions": "Solicitudes de unión",
    "group-details.group-menu.invite-users": "Invitar usuarios",
    "group-details.group-menu.danger-options": "Acciones del grupo",
    "group-details.group-menu.group-info-edit": "Editar grupo",
    "group-details.group-menu.no-join-petitions": "No hay solicitudes para unirse al grupo",
    "group-details.group-menu.invited-info": "Este usuario ha sido invitado correctamente: ",
    "group-details.group-menu.invited-info.not-found": "Este usuario no existe",
    "group-details.group-menu.invited-info.already-joined": "Este usuario ya se ha unido al grupo",
    "group-details.group-menu.invited-info.already-invited": "Este usuario ya ha sido invitado",
    "group-details.group-menu.leave-group": "Salir del grupo",
    "group-details.group-menu.leave-group.success": "Has abandonado el grupo exitosamente",
    "group-details.group-menu.delete-group": "Eliminar grupo",
    "group-details.group-menu.delete-group.error": "Hubo un error inesperado al eliminar el grupo",
    "group-details.group-menu.delete-group.success": "El grupo se ha eliminado correctamente",
    "group-details.group-menu.leave-group.error": "Eres el único usuario en el grupo. Para salir de este grupo, debes eliminarlo.",
    "group-details.group-menu.roles": "Roles",
    "group-details.group-menu.users": "Usuarios",
    "group-details.group-menu.reload-roles": "Restablecer roles de usuarios",
    "group-details.group-menu.tags": "Etiquetas",
    "group-details.group-private": "Este grupo es privado",
    "group-details.group-hidden": "Este grupo está oculto",
    "group-details.group-private.details": "Debes unirte al grupo para ver sus archivos",
    "group-details.not-found": "Grupo no encontrado",
    "group-details.not-found.details": "Este grupo no existe. Puede que haya sido eliminado",
    "group-details.invite-info": "Has sido invitado a unirte a este grupo",
    "group-details.group-private.info": "Puedes enviar una solicitud para unirte al grupo",
    "group-details.group-hidden.info": "Solo puedes unirte a grupos ocultos por invitación",
    "group-invites.group": "grupo",
    "group-invites.groups": "grupos",
    "group-invites.modal-title": "Invitaciones a grupos",
    "group-post.posted-by": "Publicado por",
    "group-post.description.show-more": "Mostrar más",
    "group-post.description.show-less": "Mostrar menos",
    "group-post.post-delete.warning.title": "Eliminar publicación",
    "group-post.post-delete.warning.message": "¿Estás seguro de que deseas eliminar esta publicación?",
    "roles.create-role": "Crear rol",
    "roles.role-form.field.name": "Nombre del rol",
    "roles.role-form.field.right-acceptUsers": "Aceptar usuarios",
    "roles.role-form.field.right-inviteUsers": "Invitar usuarios",
    "roles.role-form.field.right-manageRoles": "Gestionar roles",
    "roles.role-form.field.right-publishFiles": "Publicar archivos",
    "roles.role-form.field.right-modifyInfo": "Editar información del grupo",
    "roles.role-form.field.right-kickUsers": "Expulsar usuarios",
    "roles.role-form.field.right-manageTags": "Gestion",
    "roles.role-form.field.right-administrator": "Administrador",
    "roles.role-form.field.right-administrator-info": "El administrador tendrá todos los derechos",
    "roles.role-form.field.right-tagOwnFiles": "Etiquetar propias publicaciones",
    "roles.role-form.field.right-deletePosts": "Eliminar publicaciones",
    "roles.role-form.field.basic-rights": "Derechos básicos",
    "roles.role-form.field.user-rights": "Derechos de usuario",
    "roles.role-form.field.group-rights": "Gestión de grupos",
    "roles.role-form.field.admin-rights": "Derechos de administrador",
    "users-menu.more-users.info": "más usuarios",
    "users-menu.kick-user.confirmation": "¿Expulsar a %DISPLAY_NAME%?",
    "tags.create-tag": "Crear etiqueta",
    "tags.tag-form.field.name": "Etiqueta",
    "shared-file.title": "Archivo compartido",
    "subscriptions.unlock-info": "¡Desbloquea todo el potencial de SquadDisk con la suscripción <b>premium</b>!",
    "subscriptions.unlocked-info": "Tienes todas estas mejoras:",
    "subscriptions.upgrade.storage-title": "Aumento de almacenamiento",
    "subscriptions.upgrade.storage-info": "Obtén hasta 100 GB de almacenamiento.",
    "subscriptions.upgrade.groups-title": "Membresía de grupos ilimitada",
    "subscriptions.upgrade.groups-info": "Únete a tantos grupos como desees.",
    "subscriptions.upgrade.username-title": "Cambia de nombre!",
    "subscriptions.upgrade.username-info": "Modifica tu nombre de usuario cuando lo desees.",
    "subscriptions.upgrade.badge-title": "Insignia premium",
    "subscriptions.upgrade.badge-info": "Muestra tu estado premium con una insignia exclusiva.",
    "subscriptions.go-premium": "¡Hazte premium!",
    "app.no-posts.title": "Tu feed está vacío",
    "app.no-posts.description": "¡Prueba a unirte a grupos para ver aquí sus publicaciones!",
    "tmdb-notepad.modal-title": "Notas",
    "tmdb-notepad.modal-warning": "Tus notas son privadas y no se compartirán con otros usuarios.",
    "tmdb-notepad.modal-title-description": "¡Empieza a escribir tus notas!",
    "tmdb-notepad.modal-title-last-modified": "Modificado: {date}",
    "tmdb-result-card.info-icons.single-check": "Has empezado a ver esta serie",
    "tmdb-result-card.info-icons.double-check": "Ya has visto esto",
    "tmdb-result-card.info-icons.cannot-play": "No disponible para ver",
    "tmdb-result-card.info-icons.can-play": "Visualización disponible",
    "tmdb-result-card.info-icons.downloading": "Descarga en progreso",
    "tmdb-result-card.info-icons.has-notes": "Tienes notas para este elemento",
    "drive.file-row.error-dragging": "No se puede meter una carpeta a dentro de si misma",
    "tmdb-play-button.play": "Reproducir",
    "tmdb-item-details.view-date": "Visto el {date}",
    "tmdb-item-details.aired-date": "Emitido el {date}",
    "tmdb-item-details.release-date": "Estrenada el {date}",
    "tmdb-view-later.button.title": "Ver más tarde",
    "squadflix-home.towers-stream": "Towers Stream",
    "tmdb-view-later.button.remove-title": "Quitar de ver más tarde",
    "squadflix-home.continue-watching": "Sigue viendo",
    "squadflix-home.new-episodes": "Nuevos episodios",
    "squadflix-home.new-episodes.see-now": "¡Ver ya!",
    "squadflix-home.view-later": "Ver más tarde",
    "squadflix.serie.season": "Temporada",
    "squadflix.serie.seasons": "Temporadas",
    "squadflix.serie.episode": "Episodio",
    "squadflix.serie.episodes": "Episodios",
    "squadflix.serie": "Serie",
    "squadflix.series": "Series",
    "squadflix.live": "En vivo",
    "squadflix.movie": "Película",
    "squadflix.movies": "Películas",
    "squadflix-header.my-notes": "Mis notas",
    "squadflix-header.home": "Inicio",
    "squadflix-overview-card.show-overview": "Ver resumen",
    "squadflix-home.downloaded-torrents": "Torrents descargados",
    "torrents-dashboard.name": "Nombre",
    "torrents-dashboard.stats": "Stats",
    "torrents-dashboard.sort.date.desc": "Fecha de descarga (desc)",
    "torrents-dashboard.sort.date.asc": "Fecha de descarga (asc)",
    "torrents-dashboard.sort.size.desc": "Tamaño (desc)",
    "torrents-dashboard.sort.size.asc": "Tamaño (asc)",
    "torrents-dashboard.search": "Buscar torrents",
    "torrents-dashboard.confirm-delete": "¿Estás seguro de que deseas eliminar este torrent?",
    "torrents-dashboard.file-deleted": "Archivo eliminado correctamente",
    "tmdb-item-details.back.from-towersstream/dash": "Volver al panel",
    "tmdb-item-details.back.from-squadflix": "Volver a Squadflix",
    "tmdb-item-details.back.from-squadflixhome": "Volver a Squadflix",
    "tmdb-item-details.back.from-my-profileprivate": "Volver a Mi Perfil",
    "tmdb-item-details.back.from-home": "Volver a Inicio",
    "tmdb-item-details.back.from-squadflix-logs": "Volver a View Logs",
    "tmdb-item-details.back.from-squadflixtowersstreamdash": "Volver a TowersStream Dashboard",
    "tmdb-item-details.back.from-squadflixsearch-tmdb": "Volver a la búsqueda",
    "my-profile-collection-details.error.Forbidden": "No tienes permiso para ver esta colección",
    "userAppConfig.squadflix.header-type.0": "Peliculas y series en tendencia",
    "userAppConfig.squadflix.header-type.1": "Peliculas en tendencia",
    "userAppConfig.squadflix.header-type.2": "Series en tendencia",
    "userAppConfig.squadflix.header-type.3": "Squadflix Originals",
    "userAppConfig.squadflix.showContinueWatchingSection": "Continuar viendo",
    "userAppConfig.squadflix.showNewEpisodesSection": "Nuevos episodios",
    "userAppConfig.squadflix.showViewLaterItems": "Ver más tarde",
    "userAppConfig.squadflix.showTrendingMoviesSection": "Peliculas en tendencia",
    "userAppConfig.squadflix.showTrendingSeriesSection": "Series en tendencia",
    "userAppConfig.squadflix.showLiveTvSection": "Canales En Vivo",
    "userAppConfig.squadflix.showSquadflixOriginalsSection": "Squadflix Originals",
    "userAppConfig.squadflix.showTowersStreamSection": "Disponibles TowersStream",
    "userAppConfig.squadflix.showLaLigaEventsSection": "Eventos Fútbol",

}

